import React, { CSSProperties, Fragment, memo, FunctionComponent } from 'react';
import { IImage } from '@r3f-component-data-structure';
import * as CSS from './ImageModal.scss';
import { filestore, FsImage } from '@/filestore';
import { IUserActions, useUserStore } from '@/zustand';

interface IParentProps {
	img: IImage;
}

const ImageModal: FunctionComponent<IParentProps> = ({ img }) => {
	const userDispatch = useUserStore((state) => state.dispatch);

	const {
		filestoreId,
		scale: [sx, sy],
	} = img;
	const ratio = sy / sx;
	const vw = 90;
	const vh = 90;

	const style: CSSProperties = {
		width: `${vw}vw`,
		height: `${vh * ratio}vw`,
		maxHeight: `${vh}vh`,
		maxWidth: `${(vw * 1) / ratio}vh` /* 16/9 * 90 = 160 */,
	};

	const imageUrl = filestore.get<FsImage>(filestoreId).getImageUrl();

	const onClose = () => {
		userDispatch({
			type: IUserActions.SET_ENLARGED_IMG_ID,
			payload: null,
		});
	}

	return (
		<>
			<div className={CSS.Container} onPointerDown={onClose}>
				<img alt="enlarged" src={imageUrl} style={style} />
			</div>
			<div className={CSS.Background} />
		</>
	);
};

export default memo(ImageModal);
